import thumb1 from "../images/nft/Image.png";
import thumb2 from "../images/nft/Image-1.png";
import thumb3 from "../images/nft/Image-2.png";
import thumb4 from "../images/nft/Image-3.png";
import thumb5 from "../images/nft/Image-4.png";
import thumb6 from "../images/nft/Image-5.png";
import thumb7 from "../images/nft/Image-6.png";
import thumb8 from "../images/nft/Image-7.png";
import thumb9 from "../images/nft/Image-8.png";
import thumb10 from "../images/nft/Image-9.png";
import thumb11 from "../images/nft/Image-10.png";
import thumb12 from "../images/nft/Image-11.png";

export const products = [
  {
    thumb: thumb1,
    title: "Petcat #256",
    price: "0.25 ETH",
    likes: "124",
  },
  {
    thumb: thumb2,
    title: "Petcat #257",
    price: "0.35 ETH",
    likes: "123",
  },
  {
    thumb: thumb3,
    title: "Petcat #259",
    price: "0.50 ETH",
    likes: "150",
  },
  {
    thumb: thumb4,
    title: "Petcat #260",
    price: "0.65 ETH",
    likes: "165",
  },
  {
    thumb: thumb5,
    title: "Petcat #261",
    price: "0.85 ETH",
    likes: "185",
  },
  {
    thumb: thumb6,
    title: "Petcat #262",
    price: "1.00 ETH",
    likes: "210",
  },
  {
    thumb: thumb7,
    title: "Petcat #263",
    price: "1.15 ETH",
    likes: "225",
  },
  {
    thumb: thumb8,
    title: "Petcat #264",
    price: "1.35 ETH",
    likes: "235",
  },
  {
    thumb: thumb9,
    title: "Petcat #265",
    price: "1.50 ETH",
    likes: "250",
  },
  {
    thumb: thumb10,
    title: "Petcat #266",
    price: "2.50 ETH",
    likes: "265",
  },
  {
    thumb: thumb11,
    title: "Petcat #267",
    price: "2.85 ETH",
    likes: "270",
  },
  {
    thumb: thumb12,
    title: "Petcat #268",
    price: "3.10 ETH",
    likes: "345",
  },
];

export const categories = [
  {
    widgetTitle: "BACKGROUND",
    items: [
      {
        title: "blue",
        products: "23",
      },
      {
        title: "green",
        products: "18",
      },
      {
        title: "pink",
        products: "13",
      },
      {
        title: "red",
        products: "24",
      },
      {
        title: "rainbow",
        products: "8",
      },
      {
        title: "yellow",
        products: "57",
      },
    ],
  },
  {
    widgetTitle: "CLOTHES",
    items: [
      {
        title: "Denim",
        products: "67",
      },
      {
        title: "Black Hoodie",
        products: "35",
      },
      {
        title: "Sushi",
        products: "43",
      },
      {
        title: "Hawaii Shirt",
        products: "27",
      },
    ],
  },
  {
    widgetTitle: "Face",
    items: [
      {
        title: "pretty",
        products: "105",
      },
      {
        title: "Happy Smile",
        products: "78",
      },
      {
        title: "Blushing",
        products: "33",
      },
      {
        title: "Yummy",
        products: "41",
      },
    ],
  },
  {
    widgetTitle: "Eye",
    items: [
      {
        title: "pretty",
        products: "105",
      },
      {
        title: "Happy Smile",
        products: "78",
      },
      {
        title: "Blushing",
        products: "33",
      },
      {
        title: "Yummy",
        products: "41",
      },
    ],
  },
];
